// extracted by mini-css-extract-plugin
export default {"copy-icon__wrapper":"account-credentials-modal_copy-icon__wrapper__23U4j","credential-text":"account-credentials-modal_credential-text__3pPr7"};